import { ArticleStore } from './article.store';
import { Injectable } from '@angular/core';
import { BaseQuery } from "../base/base.query";

@Injectable({ providedIn: 'root' })
export class ArticleQuery extends BaseQuery {

    constructor(store: ArticleStore) {
        super(store);
    }
}
